import React, { useState } from 'react';

import { Dropdown, Message, Modal } from 'semantic-ui-react';

import ConfirmModal from 'components/common/ConfirmModal';
import API from 'libs/api';
import { getErrorMessage } from 'libs/errors';

import {
  SERVICE_ITEM_DISPLAY_ALL,
  SERVICE_ITEM_DISPLAY_EMPTY,
  SERVICE_ITEM_DISPLAY_OPTIONS,
} from './ServiceItemDisplayAction.constants';

export default function ServiceItemDisplayAction({ locationId }) {
  const [action, setAction] = useState(SERVICE_ITEM_DISPLAY_EMPTY);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  function onSelectServiceItemDisplayAction(_, { value }) {
    setShowConfirmation(true);
    setAction(value);
  }

  function onCancelConfirmation() {
    setShowConfirmation(false);
    setAction('');
  }

  async function onConfirmServiceItemDisplayAction() {
    setShowConfirmation(false);
    setIsLoading(true);
    setErrorMessage('');

    try {
      await API.setMerchantLocationSettings(locationId, {
        display_on_location_page: action,
      });
    } catch (error) {
      setErrorMessage(getErrorMessage(error));
      setAction(SERVICE_ITEM_DISPLAY_EMPTY);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <ConfirmModal
        open={showConfirmation}
        onCancel={onCancelConfirmation}
        onConfirm={onConfirmServiceItemDisplayAction}
        header="Change Service Item Display"
        content={
          <Modal.Content>
            By confirming, all items related to this location will be{' '}
            {action === SERVICE_ITEM_DISPLAY_ALL ? 'shown' : 'hidden'} on the location-specific
            page. Do you wish to proceed?
          </Modal.Content>
        }
      />
      <Dropdown
        placeholder="Choose Action"
        selection
        value={action}
        defaultValue={SERVICE_ITEM_DISPLAY_EMPTY}
        loading={isLoading}
        options={SERVICE_ITEM_DISPLAY_OPTIONS}
        onChange={onSelectServiceItemDisplayAction}
        selectOnBlur={false}
        selectOnNavigation={false}
      />
      {errorMessage && (
        <Message negative>
          <p>{errorMessage}</p>
        </Message>
      )}
    </>
  );
}
